import { Routes } from '@all-hands-hq/plex-graphql-schema';
import _ from 'lodash';
import React, { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { UserSettingsFragment, UserSettingsInput, useUpdateUserSettingsMutation } from '../../../graphql/gen/types';
import { AccountSettings } from './pages/AccountSettings';
import { Billing } from './pages/Billing';
import { GeneralSettings } from './pages/GeneralSettings';
import { Integrations } from './pages/Integrations';
import { Notifications } from './pages/Notifications';
import { Profile } from './pages/Profile';
import { Security } from './pages/Security';
import { Team } from './pages/Team';

type Props = {
  userProfile: UserSettingsFragment;
};
export const SettingsPages = ({ userProfile }: Props): React.ReactElement => {
  const [updateUserSettingsMutation, { loading: loadingMutation }] = useUpdateUserSettingsMutation();
  const [userSettingsChanges, setUserSettingsChanges] = useState<Partial<UserSettingsInput>>({});

  const updateDisabled = _.isEmpty(userSettingsChanges) || loadingMutation;

  const handleChange = (value: Partial<UserSettingsInput>): void => {
    if (!!value.domain) {
      setUserSettingsChanges({
        ...userSettingsChanges,
        domain: {
          ...userSettingsChanges.domain,
          ...value.domain,
        },
      });
    } else {
      setUserSettingsChanges({
        ...userSettingsChanges,
        ...value,
      });
    }
  };

  const handleSave = (): void => {
    updateUserSettingsMutation({
      variables: {
        userSettingsInput: userSettingsChanges,
      },
    }).then(() => setUserSettingsChanges({}));
  };

  const handleCancel = (): void => {
    setUserSettingsChanges({});
  };

  const pageProps = {
    savedSettings: userProfile,
    unsavedSettings: userSettingsChanges,
    onChange: handleChange,
    onSave: handleSave,
    onCancel: handleCancel,
    updateDisabled,
    loadingMutation,
  };

  return (
    <Switch>
      <Route path={Routes.GENERAL_SETTINGS_PATH}>
        <GeneralSettings {...pageProps} />
      </Route>

      <Route path={Routes.PROFILE_SETTINGS_PATH}>
        <Profile {...pageProps} />
      </Route>

      <Route path={Routes.NOTIFICATIONS_SETTINGS_PATH}>
        <Notifications />
      </Route>

      <Route path={Routes.ACCOUNT_SETTINGS_PATH}>
        <AccountSettings {...pageProps} />
      </Route>

      <Route path={Routes.SECURITY_SETTINGS_PATH}>
        <Security {...pageProps} />
      </Route>

      <Route path={Routes.INTEGRATIONS_SETTINGS_PATH}>
        <Integrations {...pageProps} />
      </Route>

      <Route path={Routes.BILLING_SETTINGS_PATH}>
        <Billing />
      </Route>

      <Route path={Routes.TEAM_SETTINGS_PATH}>
        <Team />
      </Route>

      <Redirect to={Routes.GENERAL_SETTINGS_PATH} />
    </Switch>
  );
};
